"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distance = distance;
/**
 * Calculates the distance (in metres) between two {@link Position}s
 *
 * @see Haversine formula, https://stackoverflow.com/a/11172685
 * @see [Accuracy](https://gis.stackexchange.com/a/8674)
 */
function distance(from, to) {
    /** equatorial radius of the Earth in km */
    const R = 6378.137;
    const Δlat = (to.lat * Math.PI) / 180 - (from.lat * Math.PI) / 180;
    const Δlon = (to.lng * Math.PI) / 180 - (from.lng * Math.PI) / 180;
    const a = Math.sin(Δlat / 2) * Math.sin(Δlat / 2) +
        Math.cos((from.lat * Math.PI) / 180) * Math.cos((to.lat * Math.PI) / 180) * Math.sin(Δlon / 2) * Math.sin(Δlon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    /** in mm */
    const d = R * c;
    return d * 1000;
}
